import { UserSession } from './../session/user.session';
import { Injectable, inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({
    providedIn: 'root'
  })
export class AuthGuardService {

  constructor(private router: Router, private userSession : UserSession, private authenticationService: AuthenticationService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (route.url[0].toString() == "login" || route.url[0].toString() == "p" || route.url[0].toString() == "/dashboard") {
      this.userSession.showUserDropdown = false;
      this.userSession.showMenuTop = window.innerWidth <= 991;
      this.userSession.showSideMenu = window.innerWidth <= 991;
      return true;
    }
    
    const isAuthenticated = await this.authenticationService.verifyAuthentication();
    
    if (isAuthenticated) {
            
      this.userSession.isAuthenticated.next(true);

      this.userSession.showSideMenu = true;
      this.userSession.showMenuTop = true;
      this.userSession.showUserDropdown = true;

      this.userSession.refreshSession();
      this.userSession.refreshAuthenticated();

      return true;
    } else {
      this.userSession.showUserDropdown = false;
      this.userSession.showMenuTop = window.innerWidth <= 991;
      this.userSession.showSideMenu = window.innerWidth <= 991;
      this.authenticationService.logout();
      return false;
    }
  }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
    return inject(AuthGuardService).canActivate(next, state);
  }